__turbopack_context__.v({
  "card": "gE7ggq_card",
  "image-wrapper": "gE7ggq_image-wrapper",
  "input-wrapper": "gE7ggq_input-wrapper",
  "placeholder": "gE7ggq_placeholder",
});
